/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/merkliste-table/shop.merkliste-table.component.ts.
 */
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {MerklistEntry} from '../../../../models/merklist-entry';
import {ShopMerklisteComponent} from '../merkliste/shop.merkliste.component';
import {AppMobileService} from '../../../../services/app.mobile.service';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {DomainVertreterConfig} from '../../../../models/domain-vertreter-config';
import {AppViewService} from '../../../../services/app.view.service';

/**
 * Zweck: Beschreibt class ShopMerklisteTableComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: '[merklist-table]',
    templateUrl: 'shop.merkliste-table.component.html',
    styleUrls: ['shop.merkliste-table.component.scss'],
    standalone: false
})
export class ShopMerklisteTableComponent implements OnInit, OnDestroy, OnChanges {
  @Input() entries: MerklistEntry[];
  @Input() parent: ShopMerklisteComponent;
  @Input() group: Observable<boolean>;
  @Input() label: string;
  @Input() showSelect = false;
  @Input() selectedEntryIds = {};
  @Output() selectedEntryIdsChange = new EventEmitter();

  poscount = 0;

  vcfgsub: Subscription;

  positions = [];

  vertreterconfig: BehaviorSubject<DomainVertreterConfig> = new BehaviorSubject<DomainVertreterConfig>(null);


/**
 * Beschreibt Methode resetSelection und ihren Rückgabevertrag.
 */
  resetSelection() {
    this.selectedEntryIds = {};
    this.entries.forEach(e => {
      this.selectedEntryIds[e.id] = false;
    });
  }

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public msvc: AppMobileService, private vsvc: AppViewService, private cd: ChangeDetectorRef) {
  }

  private detectChanges() {
    if (!this.cd['destroyed']) {
      this.cd.detectChanges();
    }
  }

/**
 * Beschreibt Methode selectionChanged und ihren Rückgabevertrag.
 */
  selectionChanged() {
    this.selectedEntryIdsChange.emit(this.selectedEntryIds);
  }

/**
 * Beschreibt Methode ngOnChanges und ihren Rückgabevertrag.
 */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.entries) {
      this.init();
    }
    this.detectChanges();
  }


/**
 * Beschreibt Methode init und ihren Rückgabevertrag.
 */
  init() {
    this.positions = this.entries;
    if (this.entries === null) {
      this.poscount = -1;
    } else {
      this.poscount = this.entries.length;
      this.positions.forEach(p => {
        p.valid = true;
      });
    }
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.vcfgsub = this.vsvc.$vertreterconfig.subscribe(c => {
      this.vertreterconfig.next(c);
    });
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    if (this.vcfgsub instanceof Subscription) {
      this.vcfgsub.unsubscribe();
    }
  }


}
